var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isUnifiedAccountEnabled)?_c('TransactionsView',{attrs:{"transactions-step":_vm.transactionsStep}}):_c('TransactionsLegacyView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }